import { render, staticRenderFns } from "./ParcelEntity.vue?vue&type=template&id=5dfd517a&"
import script from "./ParcelEntity.vue?vue&type=script&lang=js&"
export * from "./ParcelEntity.vue?vue&type=script&lang=js&"
import style0 from "./ParcelEntity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports